"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBlock = void 0;
var Citation_1 = require("../models/Citation");
var TextParser = /** @class */ (function () {
    function TextParser() {
    }
    TextParser.TextBlocksFromText = function (originalText) {
        var text = TextParser.replaceEmphasisWithStyle(originalText);
        var expression = new RegExp("\\[\\[(.*?)\\]\\]", "g");
        if (!expression.test(text)) {
            var textBlock = new TextBlock();
            textBlock.text = text;
            return [textBlock];
        }
        var split = text.split(expression);
        var textBlocks = [];
        for (var _i = 0, split_1 = split; _i < split_1.length; _i++) {
            var component = split_1[_i];
            var citation = Citation_1.default.citationWithTag(component);
            var textBlock = new TextBlock();
            if (citation != null) {
                textBlock.citation = citation;
            }
            else {
                textBlock.text = component;
            }
            textBlocks.push(textBlock);
        }
        return textBlocks;
    };
    TextParser.replaceEmphasisWithStyle = function (text) {
        var emphasisExpression = new RegExp("\\*\\*(.*?)\\*\\*", "g");
        var m;
        var replacementText = text;
        do {
            m = emphasisExpression.exec(text);
            if (m) {
                replacementText = replacementText.replace(m[0], "<span class=\"emphasis\">".concat(m[1], "</span>"));
            }
        } while (m);
        return replacementText;
    };
    TextParser.emailStringFromText = function (text) {
        var expression = new RegExp("\\[\\[(.*?)\\]\\]", "g");
        var m;
        var emailString = text.slice(0);
        var citations = [];
        var referenceNumber = 1;
        do {
            m = expression.exec(text);
            if (m) {
                var tag = m[1];
                citations.push(Citation_1.default.citationWithTag(tag));
                var replacement = "[".concat(referenceNumber, "]");
                emailString = emailString.replace(m[0], replacement);
                referenceNumber++;
            }
        } while (m);
        referenceNumber = 1;
        for (var _i = 0, citations_1 = citations; _i < citations_1.length; _i++) {
            var citation = citations_1[_i];
            emailString += "\n\n";
            emailString += "".concat(referenceNumber, ". ").concat(citation.text);
            referenceNumber++;
        }
        emailString = encodeURI(emailString);
        return emailString;
    };
    return TextParser;
}());
exports.default = TextParser;
var TextBlock = /** @class */ (function () {
    function TextBlock() {
    }
    return TextBlock;
}());
exports.TextBlock = TextBlock;
//# sourceMappingURL=TextParser.js.map


/** WEBPACK FOOTER **
 ** ./src/models/TextParser.js
 **/